import { render, staticRenderFns } from "./ReviewDashboardOutpatient.vue?vue&type=template&id=03b9105b&scoped=true&"
import script from "./ReviewDashboardOutpatient.vue?vue&type=script&lang=js&"
export * from "./ReviewDashboardOutpatient.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDashboardOutpatient.vue?vue&type=style&index=0&id=03b9105b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b9105b",
  null
  
)

export default component.exports